export default __webpack_public_path__ + "static/media/html5.a0ecb4dc.svg";